import { html } from 'lit'
import { IconBase } from './icon-base.js'

class Icon extends IconBase {
  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        part="svg"
      >
        <path
          d="M22 8.00007H20M20 8.00007H19C17 6.00185 14 3.99986 12 6.00007M20 8.00007V16.0001M12 6.00007L8.99956 9.0017C8.9202 9.08109 8.88052 9.12078 8.84859 9.15592C8.15499 9.91901 8.15528 11.0844 8.84927 11.8471C8.88121 11.8822 8.92098 11.922 9.00031 12.0012C9.07967 12.0805 9.11936 12.1202 9.15449 12.1521C9.91743 12.8455 11.0824 12.8453 11.8451 12.1517C11.8802 12.1198 11.9199 12.0801 11.9992 12.0008L12.9996 11.0004M12 6.00007C10 3.99986 7 6.00192 5 8.00013H4M2 8.00013H4M4 8.00013V16.0001M20 16.0001V19.0001H22M20 16.0001H17.1716M15 13.0001L16.5 14.5001C16.5796 14.5797 16.6195 14.6196 16.6515 14.6548C17.3449 15.4176 17.3449 16.5825 16.6515 17.3453C16.6195 17.3806 16.5796 17.4205 16.5 17.5001C16.4204 17.5797 16.3805 17.6196 16.3453 17.6516C15.5824 18.345 14.4176 18.345 13.6547 17.6516C13.6195 17.6196 13.5796 17.5797 13.5 17.5001L13 17.0001C12.4548 17.5453 12.1821 17.8179 11.888 17.9637C11.3285 18.241 10.6715 18.241 10.112 17.9637C9.81788 17.8179 9.54525 17.5453 9 17.0001C8.31085 17.9189 6.89563 17.7913 6.38197 16.764L6 16.0001H4M4 16.0001V19.0001H2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `
  }
}
customElements.define('handshake-icon', Icon)
